import { Branded }	from "ts-base/branded";
import { Strings }	from "ts-base/strings";
import { Equal }	from "ts-base/equal";
import { crypto }	from "ts-base/platform";
import { Textual }	from "ts-base/textual/textual";

export type UuidV4	= Branded<string, "UuidV4">;

export namespace UuidV4 {
	export const name		= "UuidV4";

	// crypto.randomUUID is specified to return lower-case hex
	// ATTENTION only supported in node >= 19
	export const fresh	= ():UuidV4 => brand(crypto.randomUUID());

	// in case we have to deal with uppercase letters
	export const reallyParse	= (it:string):UuidV4|null => fromString(it.toLowerCase());

	export const brand		= Branded.brand<UuidV4>;
	export const is			= (it:string):it is UuidV4	=> /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(it);

	export const fromString	= (it:string):UuidV4|null	=> is(it) ? brand(it) : null;
	export const toString	= (it:UuidV4):string		=> it;

	export const equal:Equal<UuidV4>	= Strings.equal;
}

// just for type checking
Textual.typed(UuidV4);
